import { types, flow } from "mobx-state-tree";
import fetcher from "../utils/fetcher";
import { getErrorMessage } from "../utils/helper";

const TasksStore = types
  .model("TasksStore", {
    error: types.frozen(),
    tasks: types.frozen(),
    statuses: types.frozen(),
    selectedTask: types.frozen(),
    types: types.frozen(),
    users: types.frozen(),
  })
  .actions((self) => {
    const getTasks = flow(function* getTasks(data) {
      self.setError("");
      self.setTasks([]);
      self.setSelectedTask("");
      const tasks = yield fetcher().post(data).from.tasks.get_tasks();

      if (tasks.status === 200 && tasks.data) {
        self.setTasks(tasks.data || []);
        if (Object.keys(self.tasks).length) {
          self.setSelectedTask(self.tasks[0]);
        }
      } else {
        console.log("error_failed_get_tasks_req");
        const errorText = "error:error_failed_get_tasks_req";
        self.setError(getErrorMessage(tasks, errorText));
      }
    });

    const getTasksBaseFilter = flow(function* getTasksBaseFilter(data) {
      self.setError("");
      self.setTasks([]);
      self.setSelectedTask("");
      const tasks = yield fetcher()
        .post(data)
        .from.tasks.get_tasks_base_filter();

      if (tasks.status === 200 && tasks.data) {
        self.setTasks(tasks.data || []);
      } else {
        console.log("error_failed_get_tasks_req");

        const errorText = "error:error_failed_get_tasks_req";
        self.setError(getErrorMessage(tasks, errorText));
      }
    });

    const getTask = flow(function* getTask(data) {
      self.setError("");
      self.setTasks([]);
      const task = yield fetcher().post(data).from.tasks.get_task();
      if (task.status === 200 && task.data) {
        return task.data;
      } else {
        console.log("error_failed_get_task_req");

        const errorText = "error:error_failed_get_task_req";
        self.setError(getErrorMessage(task, errorText));
      }
    });

    const getTaskExt = flow(function* getTaskExt(data) {
      self.setError("");
      self.setTasks([]);
      const taskExt = yield fetcher().post(data).from.tasks.get_task_ext();
      if (taskExt.status === 200 && taskExt.data) {
        return taskExt.data;
      } else {
        console.log("error_failed_get_tasks_req");

        const errorText = "error:error_failed_get_tasks_req";
        self.setError(getErrorMessage(taskExt, errorText));
      }
    });

    const getTypes = flow(function* getTypes() {
      self.setError("");
      const response = yield fetcher().get.from.tasks.get_types();
      if (response.status === 200 && response.data) {
        self.setTypes(response.data);
        return response.data;
      } else {
        const errorText = "error:error_failed_get_types";
        self.setError(getErrorMessage(response, errorText));
      }
    });

    const getUsers = flow(function* getUsers() {
      self.setError("");
      const response = yield fetcher().get.from.tasks.get_users();
      if (response.status === 200 && response.data) {
        self.setUsers(response.data);
        return response.data;
      } else {
        const errorText = "error:error_failed_get_users";
        self.setError(getErrorMessage(response, errorText));
      }
    });

    const getStatuses = flow(function* getStatuses() {
      self.setError("");
      self.setStatuses([]);
      const tasksStatusesList = yield fetcher()
        .post()
        .from.tasks.get_statuses();

      if (tasksStatusesList.status === 200 && tasksStatusesList.data) {
        self.setStatuses(tasksStatusesList.data);
        return tasksStatusesList.data;
      } else {
        const errorText = "error:error_failed_get_statuses_req";
        self.setError(getErrorMessage(tasksStatusesList, errorText));
      }
    });

    const getAvailableStatuses = flow(function* getAvailableStatuses(data) {
      self.setError("");
      self.setAvailableStatuses([]);
      const tasksAvailableStatusesList = yield fetcher()
        .post(data)
        .from.tasks.get_available_statuses();

      if (tasksAvailableStatusesList.status === 200 && tasksAvailableStatusesList.data) {
        self.setAvailableStatuses(tasksAvailableStatusesList.data);
        return tasksAvailableStatusesList.data;
      } else {
        const errorText = "error:error_failed_get_available_statusess_req";
        self.setError(getErrorMessage(tasksAvailableStatusesList, errorText));
      }
    });

    const addNewTask = flow(function* addNewTask(data) {
      self.setError("");
      const task = yield fetcher().post(data).from.tasks.new_task();
      if (task.status === 200 && task.data) {
        return task.data;
      } else {
        const errorText = "error:error_failed_add_new_task_req";
        self.setError(getErrorMessage(task, errorText));
      }
    });

    const updateTask = flow(function* updateTask(data) {
      self.setError("");
      const task = yield fetcher().post(data).from.tasks.update_task();
      if (task.status === 200 && task.data) {
        return task.data;
      } else {
        const errorText = "error:error_failed_update_task_req";
        self.setError(getErrorMessage(task, errorText));
      }
    });

    const addNewComment = flow(function* addNewComment(data) {
      self.setError("");
      const task = yield fetcher().post(data).from.tasks.add_new_comment();
      if (task.status === 200 && task.data) {
        const newComment = task.data;
        return newComment;
      } else {
        const errorText = "error:error_failed_add_new_comment_req";
        self.setError(getErrorMessage(task, errorText));
      }
    });

    const addAttachment = flow(function* addAttachment(data) {
      self.setError("");
      const attachment = yield fetcher().post(data).from.tasks.add_attachment();

      if (attachment.status === 200 && attachment.data) {
        return attachment.data;
      } else {
        const errorText = "error:error_failed_add_new_attachment_req";
        self.setError(getErrorMessage(attachment, errorText));
      }
    });

    const deleteAttachment = flow(function* deleteAttachment(data) {
      self.setError("");
      const task = yield fetcher().post(data).from.tasks.delete_attahment();
      if (task.status === 200 && task.data) {
      } else {
        const errorText = "error:error_failed_delete_comment_req";
        self.setError(getErrorMessage(task, errorText));
      }
    });

    function setError(error) {
      self.error = error;
    }

    function setTasks(tasks) {
      self.tasks = tasks;
    }

    function setStatuses(statuses) {
      self.statuses = statuses;
    }

    function setAvailableStatuses(statuses) {
      self.availableStatuses = statuses;
    }

    function setTypes(types) {
      self.types = types;
    }

    function setUsers(users) {
      self.users = users;
    }

    function setSelectedTask(task) {
      self.selectedTask = task;
    }

    return {
      getTasks,
      getTask,
      addNewComment,
      setError,
      setSelectedTask,
      setStatuses,
      getAvailableStatuses,
      setAvailableStatuses,
      setTasks,
      getTypes,
      setTypes,
      getUsers,
      setUsers,
      updateTask,
      addNewTask,
      getStatuses,
      deleteAttachment,
      addAttachment,
      getTaskExt,
      getTasksBaseFilter,
    };
  })
  .views((self) => ({
    get isError() {
      return !!self.error;
    },
  }));

const tasksStore = TasksStore.create({
  error: "",
  tasks: [],
  statuses: [],
  availableStatuses: [],
  selectedTask: undefined,
  types: [],
  users: [],
});

export default tasksStore;
